import Button from 'components/Button/Button'
import Divider from 'components/Divider'
import { Input } from 'components/Input'
import Modal from 'components/Modal'
import Select from 'components/Select'
import Table from 'components/Table'
import { Text } from 'components/Text'
import React from 'react'
import { Col, Row } from 'react-grid-system'
import { useAppState } from 'store'
import AppointmentCategoryItem from './AppointmentCategoryItem'
import { AppointmentCategoryModalProps } from './AppointmentCategoryModal.props'

const AppointmentCategoryModal: React.FC<AppointmentCategoryModalProps> = ({
  onClose,
}) => {
  const { reservationColors } = useAppState(state => state.appointments)
  return (
    <Modal
      showClose
      onClose={onClose}
      title="Appointment Categories"
      containerStyle={{ minHeight: 750 }}>
      <Row>
        <Col sm={12} style={{ margin: '20px 0px' }}>
          <Text preset="h4" color="primary" style={{ textAlign: 'center' }}>
            Existing Categories
          </Text>
        </Col>
        <Col sm={12}>
          <Table
            styles={{ width: '100%' }}
            header={['Name', 'Color', 'New Color', 'Text Color', 'Actions']}>
            <AppointmentCategoryItem />
          </Table>
        </Col>
      </Row>

      <Divider style={{ margin: '15px 0' }} />
      <Row>
        <Col sm={12} style={{ margin: '20px 0px' }}>
          <Text preset="h4" color="primary" style={{ textAlign: 'center' }}>
            New Category
          </Text>
        </Col>
        <Col xs={12} sm={12} md={6} lg={6}>
          <Input label="Name" />
        </Col>
        <Col xs={12} sm={12} md={6} lg={6}>
          <Select autocomplete options={reservationColors} label="Color" />
        </Col>
        <Col xs={12} sm={12} md={6} lg={6}>
          <Select autocomplete options={reservationColors} label="Text Color" />
        </Col>
      </Row>
      <Row>
        <Col xs={12} sm={12} md={6} lg={6}>
          <Button
            variant="primary"
            preset="filled"
            text="Submit"
            size={'small'}
          />
        </Col>
      </Row>
    </Modal>
  )
}

export default AppointmentCategoryModal
